$(function () {

    if ($('.standard_content_block__grid__inner_wrap').length < 1) {
        return;
    }

    $('.standard_content_block__grid__inner_wrap').align({
        selector: '.standard_content_block__grid__box_wrapper .standard_content_block__grid__box .standard_content_block__grid__box__title, .standard_content_block__grid__box_wrapper .standard_content_block__grid__box .standard_content_block__grid__box__description'
    });

});